/* «Настройки». Оболочка — экран React: колонка #settings.
   Содержимое колонки и листы отдаёт prepare() один раз. Дальше раздел сам меняет узлы, и React этот кадр не перерисовывает.
   Листы стоят рядом со страницей: внутри .stp-in они уехали бы вместе с прокруткой. */
import { useLayoutEffect, useState } from 'react';
import { LegacyHtml } from '../../ui/LegacyHtml';
import { settingsApi } from './module';

export function Settings() {
  const api = settingsApi();
  const [m] = useState(() => api.prepare());
  useLayoutEffect(() => {
    api.attach();
  }, [api]);
  return (
    <>
      <div className="pg stp" id="settings">
        <div className="stp-in" dangerouslySetInnerHTML={{ __html: m.body }} />
      </div>
      <LegacyHtml html={() => m.sheets} />
    </>
  );
}
